import { render, staticRenderFns } from "./ImpresionBoletos2.vue?vue&type=template&id=5c616ac2&scoped=true&"
import script from "./ImpresionBoletos2.vue?vue&type=script&lang=js&"
export * from "./ImpresionBoletos2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c616ac2",
  null
  
)

export default component.exports